export default __webpack_public_path__ + "static/media/frame.33e98a43.png";